import React from 'react';
export class ModalFooter extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'flex flex-col sm:items-center justify-end px-6 py-2 -mx-6 mt-4 gap-3 sm:flex-row bg-base-800', style: this.props.style }, this.props.children)));
        };
    }
}
